'use client';
import classNames from 'classnames';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import EcoBundle1Item, { EcoBundle1ItemProps } from './eco-bundle-1-item';
import './index.scss';

export interface EcoBundle1Props {
    /**
     * 布局方式
     *
     * swiper 左右滑动
     *
     * spread 平铺展开
     */
    layout?: 'swiper' | 'spread';
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 列表
     */
    items: EcoBundle1ItemProps[];
    /**
     * 样式名
     */
    className?: string;
    /**
     * 是否开启 affirm
     */
    isOpenAffirm?: boolean;
    /**
     * 切换子项时的回调
     */
    onChange?: (item: EcoBundle1ItemProps, index: number) => void;
}

/**
 * bundle-1
 */
export default function EcoBundle1({ theme = 'white', layout = 'swiper', items = [], className, isOpenAffirm = false }: EcoBundle1Props) {
    const prefixCls = 'eco-bundle-1';
    const total = items.length;
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-length-${total}`]: total,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-layout-${layout}`]: layout,
    });
    const [spaceBetweenN, setSpaceBetweenN] = useState(24);
    useEffect(() => {
        const initHandle = () => {
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenN(24);
            } else {
                setSpaceBetweenN(16);
            }
        };
        initHandle();
    }, []);
    return (
        <div className={compCls}>
            {layout === 'swiper' && (
                <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={spaceBetweenN}
                    navigation={{
                        nextEl: '.eco-swiper-button-next',
                        prevEl: '.eco-swiper-button-prev',
                    }}
                    modules={[Navigation]}
                >
                    {items.map((item: EcoBundle1ItemProps, index: number) => {
                        const itemStyleComp = {};
                        return (
                            <SwiperSlide key={index} className={`${prefixCls}-item`} style={itemStyleComp}>
                                <EcoBundle1Item theme={theme} {...item} isOpenAffirm={isOpenAffirm} />
                            </SwiperSlide>
                        );
                    })}
                    <div className={`eco-swiper-control eco-swiper-control-${theme}`}>
                        <div className="eco-swiper-navigation">
                            <div className="eco-swiper-button-prev">
                                <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                            </div>
                            <div className="eco-swiper-button-next">
                                <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                            </div>
                        </div>
                    </div>
                </Swiper>
            )}
            {layout === 'spread' && (
                <div className={`${prefixCls}-in-spread`}>
                    {items.map((item: EcoBundle1ItemProps, index: number) => {
                        return (
                            <div key={index} className={`${prefixCls}-item`}>
                                <EcoBundle1Item theme={theme} {...item} isOpenAffirm={isOpenAffirm} />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
